import { Box, Container, Typography, useMediaQuery, useTheme } from '@mui/material';
import type { FC } from 'react';

import { PeopleItem } from './PeopleUtils';

import type { PeopleProps } from '~/types/sanity/components';

export const People: FC<Omit<PeopleProps, '_key' | '_type'>> = ({ heading, description, people }) => {
  const theme = useTheme();
  const belowDesktop = useMediaQuery(theme.breakpoints.down('lg'));
  const aboveDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Box sx={{ py: { xs: 5, sm: 7.5 } }}>
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 7.5 }}>
          {/* Header */}
          {heading || description ? (
            <Box>
              {heading && (
                <Typography
                  variant="h3"
                  component="h2"
                  sx={{ mb: { xs: 1.875, sm: 2.5 }, ...(belowDesktop && { fontSize: 34 }) }}
                >
                  {heading}
                </Typography>
              )}

              {description && (
                <Typography variant="body1" sx={{ maxWidth: 767, ...(aboveDesktop && { fontSize: 20 }) }}>
                  {description}
                </Typography>
              )}
            </Box>
          ) : null}

          {/* People */}
          {!!people?.length && (
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: 'minmax(0, 1fr)',
                  md: 'repeat(4, minmax(180px, 1fr))',
                },
                gap: { xs: 6.75, md: 6.75 },
                px: { md: '10px' },
              }}
            >
              {people.map((person) => (
                <Box key={person._key} sx={{ display: 'inline-block', px: { md: '10px' } }}>
                  <PeopleItem key={person._key} {...person} />
                </Box>
              ))}
            </Box>
          )}
        </Box>
      </Container>
    </Box>
  );
};
